export default {"src":"/_next/static/media/facebook-bold.db9754ff.svg","height":20,"width":13,"blurWidth":0,"blurHeight":0};